import React from "react";
import { t } from "../i18n";

export const PAGE_SIZE = 20;

export const TablePagination = ({ page, pageCount, onPageChange, labels }) => {
  if (pageCount <= 1) return null;

  return (
    <div className="app-pagination" role="navigation" aria-label={labels?.aria}>
      <button
        type="button"
        className="app-secondary"
        onClick={() => onPageChange(page - 1)}
        disabled={page <= 1}
      >
        {labels?.previous}
      </button>
      <span className="app-pagination-status">
        {t(labels?.pageStatus, { page, total: pageCount })}
      </span>
      <button
        type="button"
        className="app-secondary"
        onClick={() => onPageChange(page + 1)}
        disabled={page >= pageCount}
      >
        {labels?.next}
      </button>
    </div>
  );
};
